export const STEPS = {
  SELECT_PIX: 0,
  CONFIRM_PIX: 1,
}
